var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ImageEntityBackground } from './image-entity-background';
import { ContentEntityContent } from './content-entity-content';
import { get } from 'lodash';
import { ContentEntityRichSubtitle } from './content-entity-rich-subtitle';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { classNames, truncateWords } from '@shapeable/utils';
import { useColorInfo } from '../hooks/use-color-info';
import { useLang } from '../hooks/use-lang';
import { LinkEntityButton } from './link-entity-button';
var cls = classNames('slice-banner-tout');
export var SliceBannerToutDefaultProps = {
  aspectRatio: {
    base: 4 / 3,
    landscape: 21 / 9,
    tablet: 21 / 9,
    desktop: 2.5
  },
  colors: {
    text: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n    max-width: 460px;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n    }\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    justify-content: center;\n    flex-direction: column;\n    max-width: 460px;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n    }\n  "])), theme.COLOR('link'))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 2em;\n    line-height: 1em;\n    font-family: ", ";\n    font-weight: 400;\n\n    strong, b {\n      font-weight: 500;\n      color: inherit;\n    }\n\n    p {\n      margin-bottom: 1em;\n    }\n\n    margin-bottom: ", ";\n  "], ["\n    font-size: 2em;\n    line-height: 1em;\n    font-family: ", ";\n    font-weight: 400;\n\n    strong, b {\n      font-weight: 500;\n      color: inherit;\n    }\n\n    p {\n      margin-bottom: 1em;\n    }\n\n    margin-bottom: ", ";\n  "])), theme.FONT('sans'), theme.UNIT(20)),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 3.5em;\n  "], ["\n    font-size: 3.5em;\n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 1em;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    margin-bottom: ", ";\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "]))),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 1.3em;\n  "], ["\n    font-size: 1.3em;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: inherit;\n    margin-bottom: ", ";\n    font-size: ", ";\n    max-width: 60%;\n  "], ["\n    color: inherit;\n    margin-bottom: ", ";\n    font-size: ", ";\n    max-width: 60%;\n  "])), theme.UNIT(9), theme.FONT_SIZE(10)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(12)),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    max-width: 300px;\n    margin-top: ", ";\n  "], ["\n    max-width: 300px;\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
var LinkStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    cursor: pointer;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    cursor: pointer;\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Banner: styled(ImageEntityBackground)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Body: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled(ContentEntityRichTitle).attrs(cls.attr('title'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled(ContentEntityRichSubtitle).attrs(cls.attr('subtitle'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Content: styled(ContentEntityContent).attrs(cls.attr('content'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Buttons: styled.div.attrs(cls.attr('buttons'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  LinkButton: styled(LinkEntityButton)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceBannerTout = function (props) {
  var className = props.className,
    children = props.children,
    aspectRatio = props.aspectRatio,
    entity = props.entity,
    overlayColor = props.overlayColor;
  var t = useLang();
  var content = entity.content,
    _a = entity.links,
    links = _a === void 0 ? [] : _a,
    title = entity.title,
    subtitle = entity.subtitle,
    subtitleRich = entity.subtitleRich,
    titleRich = entity.titleRich;
  var hasTitle = title || get(titleRich, 'text');
  var hasSubTitle = subtitle || get(subtitleRich, 'text');
  var hasTitles = hasTitle || hasSubTitle;
  var hasContent = content && !!content.text;
  var hasLinks = !!links.length;
  var color = useColorInfo().color;
  var truncatedText = truncateWords(content.text, {
    max: 30
  });
  var entityContentText = __assign(__assign({}, entity), {
    content: {
      text: truncatedText
    }
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Banner, {
    entity: entity,
    aspectRatio: aspectRatio,
    overlayColor: overlayColor
  }, React.createElement(My.Body, null, React.createElement(My.Header, null, hasTitles && React.createElement(React.Fragment, null, React.createElement(My.Title, {
    entity: entity
  }), React.createElement(My.Subtitle, {
    entity: entity
  }))), hasContent && React.createElement(My.Content, {
    entity: entityContentText
  }), hasLinks && React.createElement(My.Buttons, null, links.map(function (link) {
    return React.createElement(My.LinkButton, {
      entity: link,
      key: link.id
    });
  })))));
};
SliceBannerTout.defaultProps = SliceBannerToutDefaultProps;
SliceBannerTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;